<nav class="breadcrumb-container" aria-label="breadcrumb">
  @if (breadcrumbs$ | async; as breadcrumbs) {
    @if (breadcrumbs.length > 0) {
      <ol class="breadcrumb-list">
        @for (breadcrumb of breadcrumbs; track breadcrumb.url; let i = $index; let last = $last; let first = $first) {
          <li class="breadcrumb-item" [class.active]="last">
            @if (first) {
              <srp-icon icon="home" variant="outlined" size="20px" class="breadcrumb-home-icon" aria-hidden="true"></srp-icon>
            }
            @if (!last) {
              <a 
                href="#"
                (click)="navigateWithBreadcrumb(breadcrumb, i, breadcrumbs, $event)"
                class="breadcrumb-link">
                {{ breadcrumb.label }}
              </a>
              <srp-icon icon="chevron_right" variant="outlined" size="20px" color="var(--Breadcrumb-Separator, #B2B2B2)" class="breadcrumb-separator" aria-hidden="true"></srp-icon>
            } @else {
              <span class="breadcrumb-current" aria-current="page">{{ breadcrumb.label }}</span>
            }
          </li>
        }
      </ol>
    }
  }
</nav>
